<template>
  <div class="card-container">
    <v-container fluid class="header-card">
      <v-layout fill-height>
        <v-flex xs12 align-end flexbox>
          <span class="text-header">Deposit Commission</span>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" width="800">
      <template v-slot:activator="{ on }">
        <v-container
          fluid
          style="display: flex; align-items: center; justify-content: flex-end"
          ><v-btn
            append
            flat
            class="edit-btn"
            v-on="on"
            v-if="
              deposit_commission.dp_credit_commission_amount == 0 &&
              deposit_commission.dp_coin_commission_amount == 0
            "
            ><v-icon style="margin-right: 5px">edit</v-icon>Create</v-btn
          >
          <v-btn append flat class="edit-btn" v-on="on" v-else
            ><v-icon style="margin-right: 5px">edit</v-icon>Edit</v-btn
          ></v-container
        >
      </template>

      <v-card>
        <v-card-title class="headline primary" primary-title>
          <div style="font-size: 2rem; font-weight: bold">
            Edit Deposit Commission
          </div>
          <v-spacer></v-spacer>
          <div>
            <v-btn icon large @click="dialog = false"
              ><v-icon large> mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <div
          style="
            font-size: 20px;
            font-weight: bold;
            padding-inline: 30px;
            padding-top: 30px;
            text-decoration: underline;
          "
        >
          WE CREDIT
        </div>
        <div style="margin-inline: 30px; margin-block: 20px">
          <div style="background-color: #fafafa; border-radius: 5px">
            <div style="padding: 30px 10px 0px 30px; display: flex">
              <div class="front-text" style="padding-top: 3px">
                Commission type :
              </div>
              <v-radio-group v-model="weCreditType" row style="margin: 0">
                <v-radio color="primary" :label="`Credit`" :value="1"></v-radio>
                <v-radio
                  color="primary"
                  :label="`Percent`"
                  :value="2"
                ></v-radio>
              </v-radio-group>
            </div>

            <div
              style="
                padding: 20px 10px 0px 30px;
                display: flex;
                align-items: flex-start;
              "
            >
              <div class="front-text" style="padding-top: 12px">
                Commission :
              </div>
              <div style="width: 250px">
                <v-text-field
                  autofocus
                  @keypress="isNumber($event)"
                  :rules="
                    weCreditType == 1
                      ? [rules.required]
                      : [rules.required, rules.numberRule, rules.percentRule]
                  "
                  label="Enter number"
                  v-model="weCredit"
                  solo
                ></v-text-field>
              </div>
              <div
                class="front-text"
                style="padding-top: 12px; margin-left: 20px"
              >
                {{ weCreditType === 1 ? "Credit" : "%" }}
              </div>
            </div>
            <div
              v-if="weCreditType === 2"
              style="
                padding: 15px 10px 0px 30px;
                display: flex;
                align-items: flex-start;
              "
            >
              <div class="front-text" style="padding-top: 12px">
                Maximum Commission :
              </div>
              <div style="width: 250px">
                <v-text-field
                  autofocus
                  @keypress="isNumber($event)"
                  :rules="[rules.required]"
                  label="Enter number"
                  solo
                  v-model="maxWeCredit"
                ></v-text-field>
              </div>
              <div
                class="front-text"
                style="padding-top: 12px; margin-left: 20px"
              >
                Credit
              </div>
            </div>
            <div
              v-else
              style="
                padding: 15px 10px 0px 30px;
                display: flex;
                align-items: flex-start;
              "
            >
              <div class="front-text" style="padding-top: 12px; color: grey">
                Maximum Commission :
              </div>
              <div style="width: 250px">
                <v-text-field
                  disabled
                  flat
                  label="Enter number"
                  solo
                  v-model="maxWeCredit"
                ></v-text-field>
              </div>
              <div
                class="front-text"
                style="padding-top: 12px; margin-left: 20px; color: grey"
              >
                Credit
              </div>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <div
          style="
            font-size: 20px;
            font-weight: bold;
            padding-inline: 30px;
            padding-top: 30px;
            text-decoration: underline;
          "
        >
          WE COIN
        </div>
        <div style="margin-inline: 30px; margin-block: 20px">
          <div style="background-color: #fafafa; border-radius: 5px">
            <div style="padding: 30px 10px 0px 30px; display: flex">
              <div class="front-text" style="padding-top: 3px">
                Commission type :
              </div>
              <v-radio-group v-model="weCoinType" row style="margin: 0">
                <v-radio color="primary" :label="`Coin`" :value="1"></v-radio>
                <v-radio
                  color="primary"
                  :label="`Percent`"
                  :value="2"
                ></v-radio>
              </v-radio-group>
            </div>

            <div
              style="
                padding: 20px 10px 0px 30px;
                display: flex;
                align-items: flex-start;
              "
            >
              <div class="front-text" style="padding-top: 12px">
                Commission :
              </div>
              <div style="width: 250px">
                <v-text-field
                  autofocus
                  @keypress="isNumber($event)"
                  :rules="
                    weCoinType == 1
                      ? [rules.required]
                      : [rules.required, rules.percentRule]
                  "
                  label="Enter number"
                  solo
                  v-model="weCoinData"
                ></v-text-field>
              </div>
              <div
                class="front-text"
                style="padding-top: 12px; margin-left: 20px"
              >
                {{ weCoinType == 1 ? "Coin" : "%" }}
              </div>
            </div>
            <div
              v-if="weCoinType == 2"
              style="
                padding: 15px 10px 0px 30px;
                display: flex;
                align-items: flex-start;
              "
            >
              <div class="front-text" style="padding-top: 12px">
                Maximum Commission :
              </div>
              <div style="width: 250px">
                <v-text-field
                  autofocus
                  @keypress="isNumber($event)"
                  :rules="[rules.required]"
                  label="Enter number"
                  solo
                  v-model="maxWeCoin"
                ></v-text-field>
              </div>
              <div
                class="front-text"
                style="padding-top: 12px; margin-left: 20px"
              >
                Coin
              </div>
            </div>
            <div
              v-else
              style="
                padding: 15px 10px 0px 30px;
                display: flex;
                align-items: flex-start;
              "
            >
              <div class="front-text" style="padding-top: 12px; color: grey">
                Maximum Commission :
              </div>
              <div style="width: 250px">
                <v-text-field
                  disabled
                  flat
                  label="Enter number"
                  solo
                  v-model="maxWeCoin"
                ></v-text-field>
              </div>
              <div
                class="front-text"
                style="padding-top: 12px; margin-left: 20px; color: grey"
              >
                Coin
              </div>
            </div>
          </div>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="background-color: black; color: white"
            flat
            @click="updateDepositCommission()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
        <v-dialog v-model="dialog_error" width="400">
          <v-card>
            <v-card-title class="headline primary" primary-title>
              <div style="font-size: 2rem; font-weight: bold">Error</div>
            </v-card-title>
            <div
              style="
                font-size: 20px;
                padding-inline: 30px;
                padding-top: 30px;
                margin-bottom: 30px;
              "
            >
              กรุณากรอกข้อมูลให้ครบ
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="color: red" flat @click="dialog_error = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-dialog>

    <v-container
      fluid
      v-if="
        deposit_commission.dp_credit_commission_amount == 0 &&
        deposit_commission.dp_coin_commission_amount == 0
      "
    >
      <div
        style="
          display: flex;
          width: 100%;
          height: 50vh;
          justify-content: center;
          align-items: center;
          font-weight: 500;
          font-size: 4rem;
          color: #cccccc;
        "
      >
        No Commission
      </div>
    </v-container>
    <v-container fluid v-else>
      <v-layout fill-height row wrap>
        <v-flex xs12 sm6>
          <div style="margin-inline: 15px; margin-block: 20px">
            <v-card style="background-color: #f2f2f2; border-radius: 5px">
              <h2 style="padding-inline: 30px; padding-block: 10px">
                WE CREDIT
              </h2>
              <v-divider></v-divider>

              <div style="padding: 30px 10px 15px 30px; display: flex">
                <div class="front-text">Commission type :</div>
                <div class="data-text">
                  {{
                    deposit_commission.dp_credit_commission_type == 1
                      ? `Credit`
                      : `Percent`
                  }}
                </div>
              </div>

              <div style="padding: 15px 10px 15px 30px; display: flex">
                <div class="front-text">Commission :</div>
                <div class="data-text">
                  {{ deposit_commission.dp_credit_commission_amount }}
                </div>
                <div class="data-text" style="margin-left: 15px">
                  {{
                    deposit_commission.dp_credit_commission_type == 1
                      ? `Credit`
                      : `%`
                  }}
                </div>
              </div>
              <div
                v-if="deposit_commission.dp_credit_commission_type == 2"
                style="padding: 15px 10px 30px 30px; display: flex"
              >
                <div class="front-text">Maximum Commission :</div>
                <div class="data-text">
                  {{ deposit_commission.dp_credit_commission_max }}
                </div>
                <div class="data-text" style="margin-left: 15px">Credit</div>
              </div>
              <div v-else class="disable-text">Maximum Commission :</div>
            </v-card>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div style="margin-inline: 15px; margin-block: 20px">
            <v-card style="background-color: #f2f2f2; border-radius: 5px">
              <h2 style="padding-inline: 30px; padding-block: 10px">WE COIN</h2>
              <v-divider></v-divider>

              <div style="padding: 30px 10px 15px 30px; display: flex">
                <div class="front-text">Commission type :</div>
                <div class="data-text">
                  {{
                    deposit_commission.dp_coin_commission_type == 1
                      ? `Coin`
                      : `Percent`
                  }}
                </div>
              </div>

              <div style="padding: 15px 10px 15px 30px; display: flex">
                <div class="front-text">Commission :</div>
                <div class="data-text">
                  {{ deposit_commission.dp_coin_commission_amount }}
                </div>
                <div class="data-text" style="margin-left: 15px">
                  {{
                    deposit_commission.dp_coin_commission_type == 1
                      ? `WECoin`
                      : `%`
                  }}
                </div>
              </div>
              <div
                v-if="deposit_commission.dp_coin_commission_type == 2"
                style="padding: 15px 10px 30px 30px; display: flex"
              >
                <div class="front-text">Maximum Commission :</div>
                <div class="data-text">
                  {{ deposit_commission.dp_coin_commission_max }}
                </div>
                <div class="data-text" style="margin-left: 15px">Coin</div>
              </div>
              <div v-else class="disable-text">Maximum Commission :</div>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      weCoinData: 0,
      weCredit: 0,
      maxWeCoin: 0,
      maxWeCredit: 0,
      weCreditType: 1,
      weCoinType: 1,
      dialog: false,
      dialog_error: false,
      form_update: {},
      isNumber(evt) {
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        }
      },
      rules: {
        required: (value) => !!value || "Required.",
        percentRule: (value) => {
          if (!value.trim()) return true;
          if (!isNaN(parseFloat(value)) && value >= 0 && value <= 100)
            return true;
          return "Please enter number 0-100";
        },
      },
    };
  },
  computed: {
    ...mapState({
      deposit_commission: (state) =>
        state.fetchRiderCommission.deposit_commission,
    }),
  },
  created() {
    this.getDepositCommissionData();
  },
  methods: {
    async getDepositCommissionData() {
      const province = this.$route.params.province;
      let res = await this.$store.dispatch(
        "fetchRiderCommission/getDepositCommission",
        province
      );
      if (res == false) {
      } else {
        this.weCreditType =
          res.dp_credit_commission_type == null
            ? 0
            : res.dp_credit_commission_type;
        this.weCredit =
          res.dp_credit_commission_amount == null
            ? 0
            : res.dp_credit_commission_amount;
        this.maxWeCredit =
          res.dp_credit_commission_max == null
            ? 0
            : res.dp_credit_commission_max;
        this.weCoinType =
          res.dp_coin_commission_type == null ? 0 : res.dp_coin_commission_type;
        this.weCoinData =
          res.dp_coin_commission_amount == null
            ? 0
            : res.dp_coin_commission_amount;
        this.maxWeCoin =
          res.dp_coin_commission_max == null ? 0 : res.dp_coin_commission_max;
      }
    },
    async updateDepositCommission() {
      if (this.weCredit.length == 0) {
        this.dialog_error = true;
        return;
      }
      if (this.maxWeCredit.length == 0 && this.weCreditType == 2) {
        this.dialog_error = true;
        return;
      }
      if (this.weCoinData.length == 0) {
        this.dialog_error = true;
        return;
      }
      if (this.maxWeCoin.length == 0 && this.weCoinType == 2) {
        this.dialog_error = true;
        return;
      }
      let form = {
        dp_credit_commission_type: this.weCreditType,
        dp_credit_commission_amount:
          this.weCredit == "" ? 0 : parseFloat(this.weCredit),
        dp_credit_commission_maximum:
          this.maxWeCredit == "" ? 0 : parseFloat(this.maxWeCredit),
        dp_coin_commission_type: this.weCoinType,
        dp_coin_commission_amount:
          this.weCoinData == "" ? 0 : parseFloat(this.weCoinData),
        dp_coin_commission_maximum:
          this.maxWeCoin == "" ? 0 : parseFloat(this.maxWeCoin),
      };
      let data_save = {
        dp_credit_commission_type: this.weCreditType,
        dp_credit_commission_amount:
          this.weCredit == "" ? 0 : parseFloat(this.weCredit),
        dp_credit_commission_max:
          this.maxWeCredit == "" ? 0 : parseFloat(this.maxWeCredit),
        dp_coin_commission_type: this.weCoinType,
        dp_coin_commission_amount:
          this.weCoinData == "" ? 0 : parseFloat(this.weCoinData),
        dp_coin_commission_max:
          this.maxWeCoin == "" ? 0 : parseFloat(this.maxWeCoin),
      };
      let payload = {
        body: form,
        data_save: data_save,
      };
      const province = this.$route.params.province;
      let check = await this.$store.dispatch(
        "fetchRiderCommission/updateDepositCommission",
        { payload, province }
      );
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.card-container {
  border-radius: 5px;
  margin-top: 1px;
  margin-bottom: 30px;
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px 2px #00000029;
}
.header-card {
  border-radius: 5px 5px 0px 0px;
  width: 100%;
  height: 7vh;
  background-color: #ffd600;
  text-align: center;
  box-shadow: 0 4px 5px -2px #00000029;
}
.text-header {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 2rem;
}
.edit-btn {
  background-color: black;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  border-radius: 7px;
  letter-spacing: 1.15px;
  width: 130px;
  display: flex;
  padding-block: 20px;
}
.front-text {
  margin-right: 15px;
  font-weight: 600;
  font-size: 1.2rem;
  color: #4a4a4e;
}
.data-text {
  font-weight: bold;
  font-size: 1.2rem;
}
.disable-text {
  padding: 15px 10px 30px 30px;
  color: #c2c2c2;
  font-weight: 600;
  font-size: 1.2rem;
}
</style>